import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { Wrapper } from "./styled";
import { ContainerFullwidthCenterCenter } from "../../ui/Containers";
import { TitleBig } from "../../ui/Texts";
import { InputText, Button, Anchor } from "../../ui/InputControls";
import { useAlert } from "../../contexts/alert";
import { useEffect } from "react";

const VerificarConta = () => {
  let navigate = useNavigate();
  const { setClasseAlert, setAlertText, setAlertType } = useAlert();
  const [valueEmail, setValueEmail] = useState("");
  const [valueCode, setValueCode] = useState("");

  const verificar = () => {
    Auth.confirmSignUp(valueEmail, valueCode)
      .then((data) => {
        //console.log(data);
        setAlertText("Conta validada com sucesso!");
        setAlertType("success");
        setClasseAlert("on");
      })
      .catch((err) => {
        //console.log(err);
        let index = String(err).indexOf(":");
        let cleanError = String(err).substring(0, index);
        if (cleanError === "LimitExceededException") {
          setAlertText(
            "Muitas tentativas foram feitas. Tente novamente mais tarde."
          );
        } else if (cleanError === "ExpiredCodeException") {
          setAlertText("Código de verificação expirado. Solicite novamente.");
        } else if (cleanError === "CodeMismatchException") {
          setAlertText("Código inválido. Tente novamente.");
        }
        setAlertType("error");
        setClasseAlert("on");
      });
  };

  const reenviar = () => {
    Auth.resendSignUp(valueEmail)
      .then((data) => {
        //console.log(data);
        setAlertText("Código reenviado com sucesso");
        setAlertType("success");
        setClasseAlert("on");
      })
      .catch((err) => {
        //console.log(err);
        setAlertText("Ococrreu algum problema. Tente novamente.");
        setAlertType("error");
        setClasseAlert("on");
      });
  };

  const fazerLogin = () => {
    navigate("/login");
  };

  useEffect(() => {
    //console.log(valueEmail);
  }, [valueEmail]);
  return (
    <ContainerFullwidthCenterCenter>
      <Wrapper>
        <TitleBig margin="20px">LUCY.IO</TitleBig>
        <InputText
          width="250px"
          id="email"
          placeholder="Digite seu e-mail..."
          value={valueEmail}
          onChange={setValueEmail}
        />
        <InputText
          width="250px"
          id="code"
          placeholder="Código de verificação..."
          value={valueCode}
          onChange={setValueCode}
        />
        <Button
          width="200px"
          title="Ativar sua conta"
          color="primary"
          onClick={verificar}
        />
        <Button
          width="200px"
          title="Reenviar código"
          color="primary"
          onClick={reenviar}
        />
        <Anchor onClick={fazerLogin}>Fazer login</Anchor>
      </Wrapper>
    </ContainerFullwidthCenterCenter>
  );
};

export default VerificarConta;
